module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsValentine@2x.26eddfa.jpg";